import SegmentSection from "../Ondemand/SegmentSection";
import { useEffect } from "react";
import { useGetListSegmentionQuery } from "../../../services/apiSlice";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import { useDispatch, useSelector } from "react-redux";
import { setSegments } from "./../../../redux/featuresSlice/commonSlice";
import MysteryShopperCalculator from "./CalculatorMysteryShopper/MysteryShopperCalculator";

const DemographicSearch = () => {
  const dispatch = useDispatch();
  const { segmentationDataRedux = [] } = useSelector(
    (state) => state.filters || {}
  );

  const state = {
    page: 1,
    limit: 10,
  };
  const {
    data: segmentDataList,
    isLoading: isLoadingSegmentData,
    refetch,
  } = useGetListSegmentionQuery({
    limit: state.limit,
    page: state.page,
  });

  useEffect(() => {
    if (segmentDataList?.data) {
      const clonedSegments = [...segmentDataList.data];
      dispatch(setSegments(clonedSegments));
    }
  }, [segmentDataList, dispatch]);
  useEffect(() => {
    if (segmentationDataRedux.length === 0 && !isLoadingSegmentData) {
      refetch();
    }
  }, [segmentationDataRedux.length, isLoadingSegmentData, refetch]);

  return (
    <>
      <LoadingCommon statusLoading={isLoadingSegmentData} />
      {/* <div className="flex flex-col h-screen overflow-auto"> */}
      <section className="">
        <div className="">
          <section className="flex flex-col gap-3 items-center mx-auto max-w-none rounded-xl w-full">
            <div className="flex flex-col rounded-xl bg-white gap-4 w-full">
              <SegmentSection />
            </div>
            {/* <div className="flex flex-col gap-2 justify-center items-center p-3 w-full bg-white rounded-xl border border-solid border-stone-200 max-sm:p-2.5">
              <div className="flex flex-row justify-between w-full">
                <p className="text-sm text-center text-neutral-500">
                  Mystery Shoppers
                </p>
                <img src={images.InfoCircleIcon} alt="" className="w-[22px]" />
              </div>
              <div className="flex flex-row justify-between w-full">
                <p className="text-2xl font-medium text-zinc-800">100</p>
                <div></div>
              </div>
            </div> */}
            <MysteryShopperCalculator />
          </section>
        </div>
      </section>
      {/* </div> */}
    </>
  );
};

export default DemographicSearch;
